module.exports = __webpack_public_path__ + "static/dc-sao-paulo-2-42c813d683d1b88b26ee6127df1b6a6c.jpg";